import styled from 'styled-components';

export const SeparatorContainer = styled.span`
    color: ${({$colour}) => $colour};
    padding: 0 10px;
    ${({$hideOnMobile}) => $hideOnMobile ? '@media screen and (max-width: 600px) { display: none; }' : ''}
`;

SeparatorContainer.displayName = 'SeparatorContainer';